export default function Blogs(){
    return(<main className="main">
        Blogs
    </main>);
}